// extracted by mini-css-extract-plugin
export var scale = "mobileScale-module--scale--onmq7";
export var textContainer = "mobileScale-module--textContainer--aWCBh";
export var referralPic0 = "mobileScale-module--referralPic0--1eZ21";
export var referralPic1 = "mobileScale-module--referralPic1--ciVdx";
export var referralPic2 = "mobileScale-module--referralPic2--4rW9o";